import api from 'networkapp-api-connector';
import moment from 'moment';

export default {
    report: reports => {
        let {
            session: {
                user: {id: userId},
            },
        } = app.store.getState();

        return api.collect
            .report(
                reports.map(collected => ({
                    user_id: userId,
                    // statistics_token: '/* NOT IMPLEMENTED */',
                    utc_timestamp: moment(collected.timestamp).utc().toISOString(),
                    event_id: collected.report.eventId,
                    action: collected.report.action,
                    object_type: collected.report.objectType,
                    object_id: collected.report.objectId,
                    object_detail: collected.report.objectDetail,
                    context: collected.report.context,
                    user_agent: navigator.userAgent,
                }))
            )
            .then(() => {
                app.store.dispatch(app.actions.collect.reportSuccess(reports.map(collected => collected.id)));
            });
    },
};
